// @flow strict

type ApiConfig = {
  identityBaseUrl: string,
  ansaradadotcomBaseUrl: string,
  kenticoFreeTrial: string,
};

const ENVIRONMENT_HOSTNAME = ['local', 'dev1', 'staging', 'ansarada'];

const API_URL: { [key: string]: ApiConfig } = {
  local: {
    identityBaseUrl: 'https://api.local.ansarada.com/identity',
    ansaradadotcomBaseUrl: 'https://www.local.ansarada.com',
    kenticoFreeTrial: 'https://www.local.ansarada.com/free-trial',
  },
  dev1: {
    identityBaseUrl: 'https://api.dev1.ansarada.com/identity',
    ansaradadotcomBaseUrl: 'https://www.dev1.ansarada.com',
    kenticoFreeTrial: 'https://www.dev1.ansarada.com/free-trial',
  },
  staging: {
    identityBaseUrl: 'https://api.staging.ansarada.com/identity',
    ansaradadotcomBaseUrl: 'https://www.staging.ansarada.com',
    kenticoFreeTrial: 'https://www.staging.ansarada.com/free-trial',
  },
  production: {
    identityBaseUrl: 'https://api.ansarada.com/identity',
    ansaradadotcomBaseUrl: 'https://www.ansarada.com',
    kenticoFreeTrial: 'https://www.ansarada.com/free-trial',
  },
};

const DATA_ROOM_URL: { [key: string]: string } = {
  local: 'https://dataroom.ansarada.dev',
  dev1: 'https://dataroom.dev1.ansarada.com',
  staging: 'https://dataroom.staging.ansarada.com',
  production: 'https://dataroom.ansarada.com',
};

const getApiUrl = (environment: 'dev1' | 'staging' | 'production') => {
  return API_URL[environment];
};

const getEnvironment = () => {
  if (typeof window === 'undefined') return 'production';
  const env = window.location.hostname.split('.')[1];
  if (!ENVIRONMENT_HOSTNAME.includes(env)) return 'dev1';
  if (env === 'ansarada') return 'production';
  return env;
};

const env = getEnvironment();

const apiUrl = API_URL[env];
const dataRoomUrl = DATA_ROOM_URL[env];

export { apiUrl, dataRoomUrl, getApiUrl };
